import React from 'react';

const Loader = ({ fullScreen = false, message = 'Loading...' }) => {
    if (fullScreen) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center position-fixed top-0 start-0 w-100 h-100 bg-white" style={{ zIndex: 9999 }}>
                <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
                <h5 className="text-muted fw-light">{message}</h5>
            </div>
        );
    }

    return (
        <div className="d-flex flex-column align-items-center justify-content-center p-5">
            <div className="spinner-border text-primary mb-2" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            <small className="text-muted">{message}</small>
        </div>
    );
};

export default Loader;
